import { axios } from "@/lib/axios";

export const getReports = (params: any) => {
  return axios.get('/api/v1/reports/getReports', { params })
}